import store from "../../../store";
import {ACTIVE_ROOM_TYPE} from "../../../reducers/sqft/sqftMenuReducer";

/**
 * SQFT has its own mutable workspace and room switcher. During room/visualizer
 * switching the global activeQuoteIndex can already point to the target quote
 * while the workspace still contains the previous room, so SQFT persistence must
 * use the quote selected in the SQFT switcher when that switcher is in quote mode.
 **/
export const getActiveSQFTQuoteIndexFromState = (state) => {
  const activeQuoteIndex = state.quotesState.activeQuoteIndex;
  const sqftMenuState = state.sqftMenuState;

  if (sqftMenuState
    && sqftMenuState.activeRoomType === ACTIVE_ROOM_TYPE.quote
    && Number.isInteger(sqftMenuState.activeRoomIndex)) {
    return sqftMenuState.activeRoomIndex;
  }

  return activeQuoteIndex;
};

export const getActiveSQFTQuoteIndex = () => {
  return getActiveSQFTQuoteIndexFromState(store.getState());
};
